module.exports = __webpack_public_path__ + "static/media/2.2fbac61c.JPG";